/**
 * Parse the query string for defined parameters
 * @param params array of names of the query string parameters to pull
 */
export const useQueryString = (params: string[]): (string | null)[] => {
  const searchParams = new URLSearchParams(window.location.search);

  return params.map((sp) => searchParams.get(sp));
};
